import { render, staticRenderFns } from "./IssuerUserManagement.vue?vue&type=template&id=19bdc71d&scoped=true"
import script from "./IssuerUserManagement.vue?vue&type=script&setup=true&lang=ts"
export * from "./IssuerUserManagement.vue?vue&type=script&setup=true&lang=ts"
import style0 from "@/components/issuers/styles/issuer-components-style.css?vue&type=style&index=0&id=19bdc71d&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19bdc71d",
  null
  
)

/* custom blocks */
import block0 from "@/components/issuers/locales/i18n-issuer-user-management.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fbuilds%2Ftses-smartregion%2Fstadtkarte%2Fuis%2Fproficontrol-ui%2Fsrc%2Fcomponents%2Fissuers%2FIssuerUserManagement.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports